import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  DestroyRef,
  Injector,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  ViewContainerRef,
  createNgModule,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FeatureToggleService } from 'ish-core/feature-toggle.module';

import type { QuickViewComponent as OriginalComponent } from '../../shared/quick-view/quick-view.component';

@Component({
  selector: 'custom-lazy-quick-view',
  standalone: false,
  templateUrl: './lazy-quick-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyQuickViewComponent implements OnInit, OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/quick-view/shared/quick-view/quick-view.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;

  @Input() productSku: OriginalComponent['productSku'];

  @Input() detailsOnly: OriginalComponent['detailsOnly'];

  private component: ComponentRef<OriginalComponent>;
  private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

  ngOnInit() {
    this.featureToggleService
      .enabled$('quickView')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async enabled => {
        if (enabled) {
          await this.renderComponent();
        } else {
          this.anchor.clear();
        }
      });
  }

  private async renderComponent() {
    const module = await import(`../../quick-view.module`).then(m => m.QuickViewModule);

    const { QuickViewComponent: originalComponent } = await import('../../shared/quick-view/quick-view.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });

    this.ngOnChanges();

    this.component.changeDetectorRef.markForCheck();
  }

  ngOnChanges() {
    if (this.component) {
      this.component.instance.productSku = this.productSku;

      this.component.instance.detailsOnly = this.detailsOnly;
    }
  }
}
